module.exports = __webpack_public_path__ + "img/swiper_06.fe82743f.jpg";